// Crustdata's ``markets`` field on CompanyDB.
//
// Originally assumed to encode "B2B / B2C / Enterprise" segmentation,
// the live autocomplete probe revealed it actually stores STOCK
// EXCHANGE LISTING SYMBOLS — PRIVATE for unlisted, plus public
// exchange codes for listed companies.
//
// Surfaced in the UI as a "Stock Listing" filter (NOT "Markets") so
// users aren't misled. Pre-listing private companies sit under
// 'PRIVATE' which is what most ICPs want when filtering "non-public".

export interface StockListingOption {
  value: string;
  label: string;
}

export const STOCK_LISTING_OPTIONS: StockListingOption[] = [
  { value: 'PRIVATE', label: 'Private (unlisted)' },
  { value: 'NASDAQ', label: 'NASDAQ' },
  { value: 'NYSE', label: 'NYSE' },
  { value: 'AMEX', label: 'AMEX' },
  { value: 'OTC', label: 'OTC' },
  { value: 'TSX', label: 'TSX (Toronto)' },
  { value: 'LSE', label: 'LSE (London)' },
  { value: 'BSE', label: 'BSE (Bombay)' },
  { value: 'NSE', label: 'NSE (India)' },
  { value: 'TYO', label: 'TYO (Tokyo)' },
  { value: 'HKG', label: 'HKEX (Hong Kong)' },
  { value: 'SGX', label: 'SGX (Singapore)' },
  { value: 'ASX', label: 'ASX (Australia)' },
  { value: 'FRA', label: 'FRA (Frankfurt)' },
  { value: 'EPA', label: 'EPA (Euronext Paris)' },
  { value: 'AMS', label: 'AMS (Euronext Amsterdam)' },
  { value: 'SWX', label: 'SWX (Swiss)' },
  { value: 'STO', label: 'STO (Stockholm)' },
  { value: 'KRX', label: 'KRX (Korea)' },
  { value: 'SHA', label: 'SHA (Shanghai)' },
  { value: 'SHE', label: 'SHE (Shenzhen)' },
];
